export const AFFILIATE_MIN_ELIGIBILITY_VOLUME = '$1M';
export const AFFILIATE_MIN_ELIGIBILITY_FOLLOWERS = '10,000';
